











import app from "@/app";
import { OZUser } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class PUserPicEdit extends BaseComponent {
	get options() {
		return {
			enableResize: false
		};
	}
	get outputOptions() {
		return {
			type: "blob",
			format: "jpeg"
		};
	}

	finish() {
		let rCtx = app.store.routeContext,
			next = <string>rCtx.getStateItem("next");

		if (!next) {
			app.router.goBack();
		} else {
			(window as any).location = next;
		}
	}
	onEditSuccess(data: any) {
		let ctx = this,
			user = app.user.getCurrentUser(),
			formData = new FormData();

		formData.append(OZUser.COL_PICID, data.data);

		app.services.users.update(
			user.id,
			formData,
			function(response) {
				let item = response.data.item;
				app.user.setCurrentUser(item);
				ctx.finish();
			},
			function(response) {
				app.view.dialog(response);
			},
			true
		);
	}
}
